(function () {
  var STORAGE_KEY = 'blankabric:wishlist-account-cache:v2';
  var PENDING_STORAGE_KEY = 'blankabric:wishlist-pending:v1';
  var CUSTOMER_SESSION_KEY = 'blankabric:wishlist-customer-session:v1';
  var AUTH_PENDING_KEY = 'blankabric:wishlist-auth-pending:v1';
  var VIEWER_STORAGE_KEY = 'blankabric:engagement-viewer:v1';
  var API_BASE = '/apps/blankabric-wishlist';
  var config = window.BlankabricWishlistConfig || {};
  var translations = config.translations || {};
  var apiBase = config.apiBase || API_BASE;
  var directApiBase = config.directApiBase || '';
  var customerSession = consumeCustomerAuthResult() || readCustomerSession();
  var localItems = readLocalItems();
  var remoteCustomerAvailable = Boolean(customerStorageId());
  var lastRemoteError = null;
  var pendingOperations = readPendingOperations();
  var productCache = {};
  var meterPriceCache = {};
  var viewerId = null;
  var currentViewStarted = false;

  function t(key, fallback) {
    return Object.prototype.hasOwnProperty.call(translations, key) ? translations[key] : fallback;
  }

  function readCustomerSession() {
    try {
      return window.localStorage.getItem(CUSTOMER_SESSION_KEY) || '';
    } catch (_error) {
      return '';
    }
  }

  function writeCustomerSession(value) {
    customerSession = String(value || '');
    try {
      if (customerSession) {
        window.localStorage.setItem(CUSTOMER_SESSION_KEY, customerSession);
      } else {
        window.localStorage.removeItem(CUSTOMER_SESSION_KEY);
      }
    } catch (_error) {
      // The server remains the authority if browser storage is unavailable.
    }
  }

  function customerIdFromSession(value) {
    try {
      var encodedPayload = String(value || '').split('.')[0];
      var base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) base64 += '=';
      var payload = JSON.parse(window.atob(base64));
      return String(payload.customerId || '');
    } catch (_error) {
      return '';
    }
  }

  function customerStorageId() {
    return String(config.customerId || customerIdFromSession(customerSession) || '');
  }

  function consumeCustomerAuthResult() {
    if (!window.location.hash || window.location.hash.indexOf('bb_wishlist_') === -1) return '';

    var hash = new URLSearchParams(window.location.hash.slice(1));
    var session = String(hash.get('bb_wishlist_session') || '');
    var authStatus = String(hash.get('bb_wishlist_auth') || '');
    hash.delete('bb_wishlist_session');
    hash.delete('bb_wishlist_auth');

    var cleanUrl = window.location.pathname + window.location.search;
    var cleanHash = hash.toString();
    if (cleanHash) cleanUrl += '#' + cleanHash;
    window.history.replaceState(window.history.state, '', cleanUrl);

    window.BlankabricWishlistAuthResult = session ? 'authenticated' : authStatus;
    if (session) {
      try {
        window.localStorage.setItem(CUSTOMER_SESSION_KEY, session);
      } catch (_error) {
        // The session still works for the current page.
      }
      return session;
    }
    if (authStatus && authStatus !== 'required' && authStatus !== 'error') {
      try {
        window.localStorage.removeItem(AUTH_PENDING_KEY);
      } catch (_error) {
        // Nothing else to clean up.
      }
    }
    return '';
  }

  function localizeStorefrontUrl(value) {
    var raw = String(value || '').trim();
    if (!raw || raw === '#') return raw || '#';

    var rootUrl = String(config.rootUrl || '').replace(/\/+$/, '');
    if (!rootUrl || rootUrl === '/') return raw;

    try {
      var parsed = new URL(raw, window.location.origin);
      var localHosts = [window.location.hostname, config.storefrontDomain, config.permanentDomain]
        .filter(Boolean)
        .map(function (host) { return String(host).toLowerCase().replace(/^www\./, ''); });
      if (localHosts.indexOf(parsed.hostname.toLowerCase().replace(/^www\./, '')) === -1) return raw;
      if (parsed.pathname === rootUrl || parsed.pathname.indexOf(rootUrl + '/') === 0) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      var sourcePath = parsed.pathname.replace(/^\/(?:fr|en|de|nl|es|it|pt)(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
      if (!/^\/(?:products|collections|pages|blogs|search|cart|checkout)(?:\/|$)/.test(sourcePath)) return raw;
      return rootUrl + sourcePath + parsed.search + parsed.hash;
    } catch (_error) {
      return raw;
    }
  }

  function replaceToken(text, token, value) {
    return String(text || '').replace(token, value);
  }

  function readLocalItems() {
    var customerId = customerStorageId();
    if (!customerId) return [];
    try {
      var cached = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      if (String(cached.customerId || '') !== customerId) return [];
      return Array.isArray(cached.items) ? cached.items : [];
    } catch (_error) {
      return [];
    }
  }

  function readPendingOperations() {
    var customerId = customerStorageId();
    if (!customerId) return [];
    try {
      var cached = JSON.parse(window.localStorage.getItem(PENDING_STORAGE_KEY) || '{}');
      if (String(cached.customerId || '') !== customerId) return [];
      return Array.isArray(cached.operations) ? cached.operations : [];
    } catch (_error) {
      return [];
    }
  }

  function writePendingOperations(operations) {
    pendingOperations = Array.isArray(operations) ? operations : [];
    var customerId = customerStorageId();
    if (!customerId) return;
    try {
      window.localStorage.setItem(PENDING_STORAGE_KEY, JSON.stringify({
        customerId: customerId,
        operations: pendingOperations
      }));
    } catch (_error) {
      // The current page remains usable even when storage is unavailable.
    }
  }

  function queuePendingOperation(product, liked) {
    var productId = normaliseId(product.productId);
    var operations = pendingOperations.filter(function (operation) {
      return normaliseId(operation.product && operation.product.productId) !== productId;
    });
    operations.push({ product: product, liked: Boolean(liked) });
    writePendingOperations(operations);
  }

  function clearPendingOperation(productId) {
    productId = normaliseId(productId);
    writePendingOperations(pendingOperations.filter(function (operation) {
      return normaliseId(operation.product && operation.product.productId) !== productId;
    }));
  }

  function writeLocalItems(items) {
    localItems = Array.isArray(items) ? items : [];
    var customerId = customerStorageId();
    if (!customerId) {
      localItems = [];
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        customerId: customerId,
        items: localItems
      }));
    } catch (_error) {
      // Keep the wishlist usable for the current page if storage is blocked.
    }
  }

  function createViewerId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'bb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  function getViewerId() {
    if (viewerId) return viewerId;
    try {
      viewerId = window.localStorage.getItem(VIEWER_STORAGE_KEY);
      if (!viewerId) {
        viewerId = createViewerId();
        window.localStorage.setItem(VIEWER_STORAGE_KEY, viewerId);
      }
    } catch (_error) {
      viewerId = createViewerId();
    }
    return viewerId;
  }

  function analyticsProcessingAllowed() {
    return new Promise(function (resolve) {
      function readConsent() {
        try {
          resolve(Boolean(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed()));
        } catch (_error) {
          resolve(false);
        }
      }

      if (window.Shopify && window.Shopify.customerPrivacy) {
        readConsent();
        return;
      }
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        resolve(false);
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          resolve(false);
          return;
        }
        readConsent();
      });
    });
  }

  function normaliseId(value) {
    return String(value || '').replace('gid://shopify/Product/', '').trim();
  }

  function isCustomerLoggedIn() {
    return Boolean(customerStorageId()) || remoteCustomerAvailable;
  }

  function getLocalItem(productId) {
    productId = normaliseId(productId);
    return localItems.find(function (item) {
      return normaliseId(item.productId) === productId;
    });
  }

  function collectProductData(button) {
    return {
      productId: normaliseId(button.dataset.productId),
      productGid: button.dataset.productGid || '',
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      available: button.dataset.productAvailable === 'true',
      restockAlert: button.dataset.bbRestockAlert === 'true',
      restockAlertAddedLabel: button.dataset.wishlistLikedLabel || '',
      baseCount: Number(button.dataset.wishlistCount || 0) || 0,
      addedAt: new Date().toISOString()
    };
  }

  async function parseResponse(response) {
    var payload = null;
    try {
      payload = await response.json();
    } catch (_error) {
      payload = {};
    }
    return payload;
  }

  async function requestDirect(path, options) {
    if (!directApiBase || !customerSession) return null;

    var directOptions = Object.assign({}, options || {});
    directOptions.credentials = 'omit';
    directOptions.headers = Object.assign({}, directOptions.headers || {}, {
      Accept: 'application/json',
      Authorization: 'Bearer ' + customerSession,
      'Content-Type': 'application/json'
    });
    var response = await fetch(directApiBase + path, directOptions);
    var payload = await parseResponse(response);

    if (!response.ok) {
      if (response.status === 401) writeCustomerSession('');
      var error = new Error(payload.error || ('wishlist-api-' + response.status));
      error.status = response.status;
      error.payload = payload;
      throw error;
    }

    lastRemoteError = null;
    return payload;
  }

  async function request(path, options) {
    var response = await fetch(apiBase + path, Object.assign({
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }, options || {}));

    var payload = await parseResponse(response);
    if (
      customerSession &&
      ((!response.ok && response.status === 401) ||
        (response.ok && payload && payload.authenticated === false))
    ) {
      var directPayload = await requestDirect(path, options);
      if (directPayload) return directPayload;
    }

    if (!response.ok) {
      var error = new Error(payload.error || ('wishlist-api-' + response.status));
      error.status = response.status;
      error.payload = payload;
      throw error;
    }

    lastRemoteError = null;
    return payload;
  }

  function handleRemoteError(error) {
    return error;
  }

  async function loadRemoteState(productIds) {
    if (!productIds.length) return null;

    try {
      var payload = await request('/state?product_ids=' + encodeURIComponent(productIds.join(',')));
      if (typeof payload.authenticated === 'boolean') remoteCustomerAvailable = payload.authenticated;
      return payload;
    } catch (error) {
      if (error.status === 401) remoteCustomerAvailable = false;
      handleRemoteError(error);
      return null;
    }
  }

  async function trackCurrentProductView() {
    if (currentViewStarted || !config.product || !config.product.productId) return null;
    currentViewStarted = true;
    if (!(await analyticsProcessingAllowed())) return null;

    try {
      return await request('/view', {
        method: 'POST',
        body: JSON.stringify({
          product_id: normaliseId(config.product.productId),
          product_gid: config.product.productGid || '',
          handle: config.product.handle || '',
          title: config.product.title || '',
          url: config.product.url || '',
          image: config.product.image || '',
          price: config.product.price || '',
          available: config.product.available !== false,
          visitor_id: getViewerId(),
          event_id: createViewerId(),
          source: 'shopify-theme',
          analytics_allowed: true
        })
      });
    } catch (error) {
      handleRemoteError(error);
      return null;
    }
  }

  async function trackPricingCartAdd(productId, variantId, quantity, source) {
    productId = normaliseId(productId || (config.product && config.product.productId));
    if (!productId || !(await analyticsProcessingAllowed())) return null;
    try {
      return await request('/cart', {
        method: 'POST',
        body: JSON.stringify({
          product_id: productId,
          variant_id: normaliseId(variantId),
          quantity: Math.max(1, Number(quantity) || 1),
          visitor_id: getViewerId(),
          event_id: createViewerId(),
          source: source || 'shopify-theme',
          analytics_allowed: true
        })
      });
    } catch (error) {
      handleRemoteError(error);
      return null;
    }
  }

  async function toggleRemote(product, nextLiked) {
    try {
      var payload = await request('/toggle', {
        method: 'POST',
        body: JSON.stringify({
          product_id: product.productId,
          product_gid: product.productGid,
          handle: product.handle,
          title: product.title,
          url: product.url,
          image: product.image,
          price: product.price,
          available: product.available,
          liked: nextLiked
        })
      });
      remoteCustomerAvailable = true;
      clearPendingOperation(product.productId);
      var cachedItems = localItems.filter(function (item) {
        return normaliseId(item.productId) !== normaliseId(product.productId);
      });
      if (nextLiked) cachedItems.unshift(product);
      writeLocalItems(cachedItems);
      return payload;
    } catch (error) {
      lastRemoteError = error;
      if (error.status === 401) remoteCustomerAvailable = false;
      handleRemoteError(error);
      return null;
    }
  }

  async function removeRemote(productId, productGid) {
    try {
      var payload = await request('/remove', {
        method: 'POST',
        body: JSON.stringify({
          product_id: normaliseId(productId),
          product_gid: productGid || ''
        })
      });
      remoteCustomerAvailable = true;
      clearPendingOperation(productId);
      writeLocalItems(localItems.filter(function (item) {
        return normaliseId(item.productId) !== normaliseId(productId);
      }));
      return payload;
    } catch (error) {
      lastRemoteError = error;
      if (error.status === 401) remoteCustomerAvailable = false;
      handleRemoteError(error);
      return null;
    }
  }

  async function loadRemoteList() {
    try {
      var payload = await request('/list');
      remoteCustomerAvailable = true;
      writeLocalItems(Array.isArray(payload.items) ? payload.items : []);
      return payload;
    } catch (error) {
      lastRemoteError = error;
      if (error.status === 401) remoteCustomerAvailable = false;
      handleRemoteError(error);
      return null;
    }
  }

  async function loadRemoteSummary() {
    try {
      var payload = await request('/summary');
      if (typeof payload.authenticated === 'boolean') remoteCustomerAvailable = payload.authenticated;
      if (customerStorageId() && payload.authenticated === false) {
        return { total: localItems.length, unread: 0, notifications: [] };
      }
      return payload;
    } catch (error) {
      lastRemoteError = error;
      if (error.status === 401) remoteCustomerAvailable = false;
      handleRemoteError(error);
      return {
        total: localItems.length,
        unread: 0,
        notifications: []
      };
    }
  }

  function productButtons(productId) {
    productId = normaliseId(productId);
    return Array.from(document.querySelectorAll('[data-bb-wishlist-toggle]')).filter(function (button) {
      return normaliseId(button.dataset.productId) === productId;
    });
  }

  function productCounters(productId) {
    productId = normaliseId(productId);
    return Array.from(document.querySelectorAll('[data-bb-wishlist-count]')).filter(function (counter) {
      var counterProductId = normaliseId(counter.dataset.productId);
      if (counterProductId) return counterProductId === productId;

      var host = counter.closest('[data-bb-wishlist-toggle], [data-bb-wishlist-product]');
      return host && normaliseId(host.dataset.productId) === productId;
    });
  }

  function updateWishlistCounter(counter, count) {
    var total = Number(count || 0);
    if (!Number.isFinite(total) || total < 0) total = 0;

    if (counter.dataset.bbWishlistCountLabel === 'favorites') {
      counter.textContent = total + ' ' + (total === 1 ? t('favoriteSingular', 'favori') : t('favoritePlural', 'favoris'));
    } else {
      counter.textContent = String(total);
    }

    if (counter.dataset.bbWishlistCountAccessible === 'true') {
      counter.setAttribute(
        'aria-label',
        total + ' ' + (total === 1 ? t('favoriteSingular', '') : t('favoritePlural', ''))
      );
    }

    counter.hidden = counter.dataset.bbWishlistCountMode === 'always' ? false : total <= 0;
  }

  function updateViewCounter(counter, count) {
    var total = Number(count || 0);
    var minimum = Number(counter.dataset.minimum || 0);
    if (!Number.isFinite(total) || total < 0) total = 0;
    if (!Number.isFinite(minimum) || minimum < 0) minimum = 0;
    counter.textContent = total + ' ' + (total === 1 ? t('viewSingular', 'vue ces 7 derniers jours') : t('viewPlural', 'vues ces 7 derniers jours'));
    counter.hidden = total < minimum;
  }

  function setProductViews(productId, count) {
    productId = normaliseId(productId);
    document.querySelectorAll('[data-bb-view-count]').forEach(function (counter) {
      if (normaliseId(counter.dataset.productId) === productId) updateViewCounter(counter, count);
    });
  }

  function setButtonState(button, liked, count) {
    var defaultLabel = button.dataset.wishlistDefaultLabel || t('addToFavorites', 'Add to favorites');
    var likedLabel = button.dataset.wishlistLikedLabel || t('inFavorites', 'Saved to favorites');
    button.classList.toggle('is-liked', Boolean(liked));
    button.setAttribute('aria-pressed', liked ? 'true' : 'false');
    button.setAttribute('aria-label', liked ? likedLabel : defaultLabel);
    button.dataset.wishlistLiked = liked ? 'true' : 'false';

    var label = button.querySelector('[data-bb-wishlist-label]');
    if (label) {
      label.textContent = liked
        ? (button.dataset.wishlistLikedLabel || t('inFavorites', 'Bien ajouté à mes favoris'))
        : (button.dataset.wishlistDefaultLabel || t('addToFavorites', 'Ajouter aux favoris'));
      label.textContent = liked ? likedLabel : defaultLabel;
    }

    button.querySelectorAll('[data-bb-wishlist-count]').forEach(function (counter) {
      updateWishlistCounter(counter, count);
    });
  }

  function setProductState(productId, liked, count) {
    productButtons(productId).forEach(function (button) {
      setButtonState(button, liked, count);
    });

    productCounters(productId).forEach(function (counter) {
      updateWishlistCounter(counter, count);
    });
  }

  function animateProductCardHeart(productId) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    productButtons(productId).forEach(function (button) {
      if (!button.classList.contains('bb-product-card__heart')) return;
      var animationHost = button.closest('.bb-product-card__wishlist-action');
      if (!animationHost) return;

      animationHost.classList.remove('is-bursting');
      void animationHost.offsetWidth;
      animationHost.classList.add('is-bursting');
      window.setTimeout(function () {
        animationHost.classList.remove('is-bursting');
      }, 650);
    });
  }

  function hydrateLocalButtons() {
    document.querySelectorAll('[data-bb-wishlist-toggle]').forEach(function (button) {
      var product = collectProductData(button);
      var liked = Boolean(getLocalItem(product.productId));
      var count = product.baseCount + (liked ? 1 : 0);
      setButtonState(button, liked, count);
    });
  }

  function applyLocalWishlistState(product, liked) {
    var productId = normaliseId(product.productId);
    var cachedItems = localItems.filter(function (item) {
      return normaliseId(item.productId) !== productId;
    });
    if (liked) cachedItems.unshift(product);
    writeLocalItems(cachedItems);
    queuePendingOperation(product, liked);

    var fallbackCount = Math.max(0, Number(product.baseCount || 0) + (liked ? 1 : 0));
    setProductState(productId, liked, fallbackCount);
    renderSummary({ total: localItems.length, unread: 0 });
  }

  async function flushPendingOperations() {
    if (!customerStorageId() || !pendingOperations.length) return false;

    var operations = pendingOperations.slice();
    var changed = false;

    for (var index = 0; index < operations.length; index += 1) {
      var operation = operations[index];
      var product = operation.product || {};

      try {
        var payload = await request('/toggle', {
          method: 'POST',
          body: JSON.stringify({
            product_id: normaliseId(product.productId),
            product_gid: product.productGid || '',
            handle: product.handle || '',
            title: product.title || '',
            url: product.url || '',
            image: product.image || '',
            price: product.price || '',
            available: product.available !== false,
            liked: operation.liked === true
          })
        });
        remoteCustomerAvailable = true;
        clearPendingOperation(product.productId);
        setProductState(product.productId, payload.liked, payload.count);
        changed = true;
      } catch (error) {
        lastRemoteError = error;
        if (error.status === 401) remoteCustomerAvailable = false;
        handleRemoteError(error);
        break;
      }
    }

    return changed;
  }

  async function hydrateRemoteButtons() {
    var ids = Array.from(document.querySelectorAll('[data-bb-wishlist-toggle]'))
      .map(function (button) { return normaliseId(button.dataset.productId); })
      .filter(Boolean);
    ids = Array.from(new Set(ids));

    var state = await loadRemoteState(ids);
    if (!state || !state.products) return false;

    Object.keys(state.products).forEach(function (productId) {
      var productState = state.products[productId];
      var localItem = getLocalItem(productId);
      var preserveLocalState = Boolean(customerStorageId()) && state.authenticated !== true && Boolean(localItem);
      setProductState(
        productId,
        preserveLocalState ? true : productState.liked,
        Number(productState.count || 0) + (preserveLocalState ? 1 : 0)
      );
      setProductViews(productId, productState.views7d);
    });

    if (state.authenticated && customerStorageId()) {
      var visibleIds = ids.map(normaliseId);
      var cachedItems = localItems.filter(function (item) {
        return visibleIds.indexOf(normaliseId(item.productId)) === -1;
      });

      Object.keys(state.products).forEach(function (productId) {
        if (!state.products[productId].liked) return;
        var button = productButtons(productId)[0];
        if (button) cachedItems.unshift(collectProductData(button));
      });

      writeLocalItems(cachedItems);
    }

    return true;
  }

  function renderSummary(summary) {
    summary = summary || { total: localItems.length, unread: 0 };

    document.querySelectorAll('[data-bb-wishlist-total]').forEach(function (node) {
      var total = Number(summary.total || 0);
      node.textContent = String(total);
      node.hidden = total <= 0;
    });

    document.documentElement.classList.toggle('bb-wishlist-has-items', Number(summary.total || 0) > 0);
  }

  async function hydrateSummary() {
    var summary = await loadRemoteSummary();
    renderSummary(summary);

    var restockNotification = Array.isArray(summary.notifications)
      ? summary.notifications.find(function (notification) {
          return notification && notification.read !== true && notification.type === 'restocked';
        })
      : null;

    if (restockNotification) {
      showRestockNotification(restockNotification);
      request('/notifications/read', {
        method: 'POST',
        body: JSON.stringify({ ids: [restockNotification.id] })
      }).catch(function () {
        // The notification can safely be shown again if marking it as read fails.
      });
    }
  }

  function showAccountToast(message) {
    ensureToastStyles();

    var existing = document.querySelector('[data-bb-wishlist-toast]');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'bb-wishlist-toast';
    toast.dataset.bbWishlistToast = '';
    toast.textContent = message || t('addedLocal', 'Favori ajoute.');

    document.body.appendChild(toast);
    revealWishlistToast(toast);
    scheduleWishlistToastRemoval(toast);
  }

  function revealWishlistToast(toast) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (toast.parentNode) toast.classList.add('is-visible');
      });
    });
  }

  function scheduleWishlistToastRemoval(toast) {
    window.setTimeout(function () {
      if (!toast.parentNode) return;
      toast.classList.remove('is-visible');
      toast.classList.add('is-leaving');
      window.setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, 460);
    }, 4800);
  }

  function wishlistLinkLabel() {
    var locale = String(config.locale || '').toLowerCase();
    if (locale.indexOf('fr') === 0) return 'Voir mes favoris';
    if (locale.indexOf('en') === 0) return 'View my favorites';
    return t('myFavorites', 'Mes favoris');
  }

  function wishlistAddedMessage() {
    var locale = String(config.locale || '').toLowerCase();
    if (locale.indexOf('fr') === 0) return 'Article bien ajouté aux favoris.';
    if (locale.indexOf('en') === 0) return 'Item added to favorites.';
    return t('addedLocal', 'Article bien ajouté aux favoris.');
  }

  function showWishlistAddedToast(message) {
    ensureToastStyles();

    var existing = document.querySelector('[data-bb-wishlist-toast]');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'bb-wishlist-toast bb-wishlist-toast--success';
    toast.dataset.bbWishlistToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var label = document.createElement('span');
    label.className = 'bb-wishlist-toast__message';
    label.textContent = message || wishlistAddedMessage();

    var link = document.createElement('a');
    link.className = 'bb-wishlist-toast__link';
    link.href = localizeStorefrontUrl(config.wishlistPageUrl || '/pages/mes-favoris');
    link.textContent = wishlistLinkLabel();

    toast.appendChild(label);
    toast.appendChild(link);
    document.body.appendChild(toast);
    revealWishlistToast(toast);
    scheduleWishlistToastRemoval(toast);
  }

  function showRestockNotification(notification) {
    ensureToastStyles();

    var existing = document.querySelector('[data-bb-wishlist-toast]');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'bb-wishlist-toast bb-wishlist-toast--success';
    toast.dataset.bbWishlistToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var label = document.createElement('span');
    label.className = 'bb-wishlist-toast__message';
    label.textContent = notification.message || t('restockAlertAdded', 'Back in stock');
    toast.appendChild(label);

    if (notification.productUrl) {
      var link = document.createElement('a');
      link.className = 'bb-wishlist-toast__link';
      link.href = localizeStorefrontUrl(notification.productUrl);
      link.textContent = t('restockViewProduct', 'View product');
      toast.appendChild(link);
    }

    document.body.appendChild(toast);
    revealWishlistToast(toast);
    scheduleWishlistToastRemoval(toast);
  }

  function favoriteAddedMessage(product) {
    if (product && product.restockAlert) {
      return product.restockAlertAddedLabel || t('restockAlertAdded', 'Restock alert active');
    }
    return undefined;
  }

  function guestOfferPercent() {
    var value = Number(config.guestOfferPercent || 0);
    return Number.isFinite(value) && value > 0 ? Math.round(value) : 0;
  }

  function guestOfferHtml() {
    var percent = guestOfferPercent();
    if (config.guestOfferEnabled === false || percent <= 0) return '';
    return '<p class="bb-wishlist-login-modal__offer"><strong>-' + percent + ' %</strong><span>' + escapeHtml(t('firstOrderOffer', 'sur votre première commande')) + '</span></p>';
  }

  function guestOfferTitle() {
    return String(config.guestOfferTitle || 'Gardez vos coups de cœur');
  }

  function guestOfferText() {
    return String(config.guestOfferText || 'Créez un compte pour retrouver vos favoris sur tous vos appareils.');
  }

  function storeAuthPendingAction(action) {
    try {
      if (action) {
        window.localStorage.setItem(AUTH_PENDING_KEY, JSON.stringify(action));
      } else {
        window.localStorage.removeItem(AUTH_PENDING_KEY);
      }
    } catch (_error) {
      // The authentication flow can still continue without replaying the click.
    }
  }

  function authActionWithReturnContext(action) {
    if (!action) return null;
    return Object.assign({}, action, {
      returnPath: window.location.pathname + window.location.search,
      scrollX: Math.max(0, Math.round(window.scrollX || 0)),
      scrollY: Math.max(0, Math.round(window.scrollY || 0))
    });
  }

  function restoreAuthReturnPosition(action) {
    if (!action || action.returnPath !== window.location.pathname + window.location.search) return;

    var scrollX = Number(action.scrollX || 0);
    var scrollY = Number(action.scrollY || 0);
    if (!Number.isFinite(scrollX) || !Number.isFinite(scrollY)) return;

    var restore = function () {
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'auto' });
    };
    window.requestAnimationFrame(restore);
    window.setTimeout(restore, 180);
    window.setTimeout(restore, 650);
  }

  function customerAuthenticationUrl(interactive) {
    if (!config.customerAuthStartUrl) return '';

    var returnTo = window.location.href.split('#')[0];
    var target = config.customerAuthStartUrl + '?return_to=' + encodeURIComponent(returnTo);
    if (interactive) target += '&interactive=1';
    return target;
  }

  function beginCustomerAuthentication(action) {
    storeAuthPendingAction(authActionWithReturnContext(action));
    showHeaderLoginMessage();
    return false;
  }

  async function replayAuthPendingAction() {
    if (!customerStorageId()) return false;

    var action = null;
    try {
      action = JSON.parse(window.localStorage.getItem(AUTH_PENDING_KEY) || 'null');
    } catch (_error) {
      action = null;
    }
    if (!action || !action.type) return false;
    restoreAuthReturnPosition(action);

    var result = null;
    if (action.type === 'toggle' && action.product) {
      result = await toggleRemote(action.product, action.liked === true);
      if (result) {
        setProductState(action.product.productId, result.liked, result.count);
        if (action.liked === true && result.liked) showWishlistAddedToast(favoriteAddedMessage(action.product));
      }
    } else if (action.type === 'remove' && action.productId) {
      result = await removeRemote(action.productId, action.productGid || '');
      if (result) setProductState(action.productId, false, result.count || 0);
    }

    if (!result) return false;
    storeAuthPendingAction(null);
    return true;
  }

  function showHeaderLoginMessage() {
    ensureToastStyles();
    var authUrl = config.storefrontLoginUrl || customerAuthenticationUrl(true) || config.loginUrl || '/account/login';

    var existingToast = document.querySelector('[data-bb-wishlist-toast]');
    if (existingToast) existingToast.remove();

    var existingModal = document.querySelector('[data-bb-wishlist-login-modal]');
    if (existingModal) existingModal.remove();

    var modal = document.createElement('div');
    modal.className = 'bb-wishlist-login-modal';
    modal.dataset.bbWishlistLoginModal = '';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', guestOfferTitle());
    modal.innerHTML =
      '<div class="bb-wishlist-login-modal__card">' +
        '<button class="bb-wishlist-login-modal__close" type="button" aria-label="' + escapeHtml(t('close', 'Fermer')) + '" data-bb-wishlist-login-close>&times;</button>' +
        '<p class="bb-wishlist-login-modal__eyebrow">' + escapeHtml(t('accountRequired', 'Compte requis')) + '</p>' +
        '<h2 class="bb-wishlist-login-modal__message">' + escapeHtml(guestOfferTitle()) + '</h2>' +
        '<p class="bb-wishlist-login-modal__text">' + escapeHtml(guestOfferText()) + '</p>' +
        guestOfferHtml() +
        '<div class="bb-wishlist-login-modal__actions">' +
          '<a class="bb-wishlist-login-modal__primary" href="' + escapeHtml(authUrl) + '">' + escapeHtml(t('createMyAccount', 'Créer mon compte')) + '</a>' +
          '<a class="bb-wishlist-login-modal__secondary" href="' + escapeHtml(authUrl) + '">' + escapeHtml(t('alreadyHaveAccount', 'J’ai déjà un compte')) + '</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });

    function closeModal() {
      modal.classList.remove('is-open');
      window.setTimeout(function () {
        if (modal.parentNode) modal.remove();
      }, 220);
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeModal();
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-bb-wishlist-login-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', onKeydown);
  }

  function ensureToastStyles() {
    if (document.querySelector('[data-bb-wishlist-toast-style]')) return;

    var style = document.createElement('style');
    style.dataset.bbWishlistToastStyle = '';
    style.textContent = [
      '.bb-product-card__option-choice[hidden],.bb-product-card__option-choice.is-unavailable-hidden{display:none!important;}',
      '.blankabric-variant-picker label:has(> input[type="radio"][data-option-available="false"]){display:none!important;}',
      '.bb-wishlist-toast{position:fixed;left:50%;bottom:22px;z-index:2147483000;max-width:min(420px,calc(100vw - 28px));transform:translate(-50%,14px) scale(.98);padding:12px 16px;border:1px solid rgba(84,51,52,.16);border-radius:999px;background:#fff8f0;color:#543334;box-shadow:0 16px 40px rgba(35,29,24,.16);font-size:14px;line-height:1.35;text-align:center;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .38s ease,transform .48s cubic-bezier(.16,1,.3,1),visibility 0s linear .48s;will-change:opacity,transform;}',
      '.bb-wishlist-toast.is-visible{transform:translate(-50%,0) scale(1);opacity:1;visibility:visible;pointer-events:auto;transition-delay:0s;}',
      '.bb-wishlist-toast.is-leaving{transform:translate(-50%,9px) scale(.985);opacity:0;visibility:visible;pointer-events:none;transition:opacity .32s ease,transform .38s ease;}',
      '.bb-wishlist-toast a{color:inherit;font-weight:700;text-underline-offset:3px;}',
      '.bb-wishlist-toast--success{display:flex;align-items:center;justify-content:space-between;gap:14px;width:max-content;max-width:min(560px,calc(100vw - 28px));padding:10px 10px 10px 16px;text-align:left;}',
      '.bb-wishlist-toast__message{min-width:0;}',
      '.bb-wishlist-toast__link{display:inline-flex;align-items:center;justify-content:center;min-height:36px;flex:0 0 auto;padding:0 14px;border-radius:999px;background:#543334;color:#fff8f0!important;text-decoration:none;white-space:nowrap;}',
      '@media(max-width:520px){.bb-wishlist-toast--success{align-items:stretch;width:calc(100vw - 28px);padding:12px;border-radius:12px;flex-direction:column;gap:10px;text-align:center;}.bb-wishlist-toast__link{width:100%;}}',
      '.bb-wishlist-toast--account{border-radius:8px;}',
      '.bb-wishlist-toast[hidden]{display:none;}',
      '.bb-wishlist-login-modal{position:fixed;inset:0;z-index:2147483001;display:grid;place-items:center;padding:22px;background:rgba(30,24,20,.36);opacity:0;pointer-events:none;transition:opacity .2s ease;}',
      '.bb-wishlist-login-modal.is-open{opacity:1;pointer-events:auto;}',
      '.bb-wishlist-login-modal__card{position:relative;width:min(520px,100%);padding:34px 30px 30px;border:1px solid rgba(84,51,52,.14);border-radius:10px;background:#fffaf4;color:#543334;box-shadow:0 24px 70px rgba(35,29,24,.24);text-align:center;transform:translateY(12px) scale(.98);transition:transform .22s ease;}',
      '.bb-wishlist-login-modal.is-open .bb-wishlist-login-modal__card{transform:translateY(0) scale(1);}',
      '.bb-wishlist-login-modal__close{position:absolute;top:12px;right:12px;width:34px;height:34px;border:1px solid rgba(84,51,52,.18);border-radius:999px;background:#fff;color:#543334;font-size:22px;line-height:1;cursor:pointer;}',
      '.bb-wishlist-login-modal__eyebrow{margin:0 0 12px;font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;}',
      '.bb-wishlist-login-modal__message{margin:0 auto 12px;max-width:430px;font-family:var(--font-accent--family,var(--font-heading--family,serif));font-size:clamp(25px,3vw,34px);font-weight:500;line-height:1.15;}',
      '.bb-wishlist-login-modal__text{max-width:420px;margin:0 auto 18px;color:rgba(84,51,52,.78);font-size:15px;line-height:1.5;}',
      '.bb-wishlist-login-modal__offer{display:inline-flex;align-items:center;gap:10px;margin:0 auto 22px;padding:9px 14px;border:1px solid rgba(84,51,52,.16);border-radius:999px;background:#f4e7dc;color:#543334;}',
      '.bb-wishlist-login-modal__offer strong{font-size:18px;}.bb-wishlist-login-modal__offer span{font-size:13px;font-weight:700;}',
      '.bb-wishlist-login-modal__actions{display:flex;justify-content:center;flex-wrap:wrap;gap:10px;}',
      '.bb-wishlist-login-modal__primary,.bb-wishlist-login-modal__secondary{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:0 18px;border-radius:999px;text-decoration:none;font-size:14px;}',
      '.bb-wishlist-login-modal__primary{background:#543334;color:#fff8f0;}',
      '.bb-wishlist-login-modal__secondary{border:1px solid rgba(84,51,52,.22);background:#fff;color:#543334;}',
      '.bb-wishlist-panel{position:fixed;inset:0;z-index:2147482999;display:grid;justify-items:end;background:rgba(30,24,20,.28);}',
      '.bb-wishlist-panel[hidden]{display:none!important;}',
      '.bb-wishlist-panel{opacity:0;pointer-events:none;transition:opacity .28s ease;}',
      '.bb-wishlist-panel.is-open{opacity:1;pointer-events:auto;}',
      '.bb-wishlist-panel__inner{width:min(430px,100vw);height:100%;overflow:auto;background:#fffaf4;color:#2f2a24;box-shadow:-18px 0 44px rgba(35,29,24,.18);padding:22px;transform:translateX(100%);transition:transform .34s cubic-bezier(.22,.61,.36,1);}',
      '.bb-wishlist-panel.is-open .bb-wishlist-panel__inner{transform:translateX(0);}',
      '.bb-wishlist-panel__head{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin-bottom:18px;}',
      '.bb-wishlist-panel__eyebrow{margin:0 0 4px;color:#543334;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;}',
      '.bb-wishlist-panel__title{margin:0;font-family:var(--font-accent--family,var(--font-heading--family,serif));font-size:34px;font-weight:400;line-height:1;}',
      '.bb-wishlist-panel__close{width:36px;height:36px;border:1px solid rgba(84,51,52,.18);border-radius:999px;background:#fff;color:#543334;font-size:22px;line-height:1;cursor:pointer;}',
      '.bb-wishlist-panel__message{margin:0;padding:14px;border:1px solid rgba(84,51,52,.14);border-radius:8px;background:#fff;color:#543334;line-height:1.5;}',
      '.bb-wishlist-panel__message a{color:inherit;font-weight:700;text-underline-offset:3px;}',
      '.bb-wishlist-panel__grid{display:grid;gap:12px;}',
      '.bb-wishlist-panel__item{display:grid;grid-template-columns:82px minmax(0,1fr);gap:12px;align-items:center;padding:10px;border:1px solid rgba(84,51,52,.12);border-radius:8px;background:#fff;transition:opacity .28s ease,transform .38s cubic-bezier(.16,1,.3,1);}',
      '.bb-wishlist-panel__media{display:block;aspect-ratio:1/1.12;border-radius:6px;overflow:hidden;background:#f3ece3;}',
      '.bb-wishlist-panel__media img{width:100%;height:100%;object-fit:cover;display:block;}',
      '.bb-wishlist-panel__item-title{margin:0 0 6px;font-size:15px;font-weight:700;line-height:1.22;}',
      '.bb-wishlist-panel__item-title a{color:inherit;text-decoration:none;}',
      '.bb-wishlist-panel__price{margin:0;color:#543334;font-weight:700;}',
      '.bb-wishlist-panel__status{margin:6px 0 0;color:rgba(47,42,36,.62);font-size:12px;}',
      '.bb-wishlist-panel__actions{display:flex;align-items:center;gap:8px;margin-top:10px;}',
      '.bb-wishlist-panel__add{display:inline-flex;align-items:center;justify-content:center;gap:7px;width:34px;min-width:34px;min-height:34px;padding:0;border:0;border-radius:999px;background:#543334;color:#fff8f0;font:inherit;font-size:13px;cursor:pointer;}',
      '.bb-wishlist-panel__add svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;}',
      '.bb-wishlist-panel__add-label{display:none;}',
      '.bb-wishlist-panel__add:disabled{opacity:.5;cursor:not-allowed;}',
      '.bb-wishlist-panel__favorite{display:inline-flex;align-items:center;justify-content:center;width:34px;min-width:34px;min-height:34px;padding:0;border:1px solid #543334;border-radius:999px;background:#543334;color:#fff8f0;cursor:pointer;transition:opacity .2s ease,transform .28s cubic-bezier(.16,1,.3,1);}',
      '.bb-wishlist-panel__favorite svg{width:16px;height:16px;fill:currentColor;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;}',
      '.bb-wishlist-panel__favorite:disabled{opacity:.5;cursor:not-allowed;}',
      '.bb-wishlist-panel__item.is-removing{opacity:0;transform:translateX(18px) scale(.98);pointer-events:none;}',
      '.bb-wishlist-options-card{position:fixed;inset:0;z-index:2147483002;pointer-events:none;}',
      '.bb-wishlist-options-card.bb-options-active{pointer-events:auto;}',
      '.bb-wishlist-options-card .bb-product-card__options-modal{--bb-options-backdrop-bg:rgba(29,25,23,.38);--bb-options-backdrop-blur:6px;position:fixed;inset:0;z-index:2147483002;display:flex;align-items:flex-end;justify-content:center;padding:16px;pointer-events:none;}',
      '.bb-wishlist-options-card .bb-product-card__options-modal.is-open{pointer-events:auto;}',
      '.bb-wishlist-options-card .bb-product-card__options-backdrop{position:absolute;inset:0;border:0;background-color:rgba(29,25,23,0);backdrop-filter:blur(0);-webkit-backdrop-filter:blur(0);cursor:pointer;transition:background-color .72s linear,backdrop-filter .72s linear,-webkit-backdrop-filter .72s linear;will-change:background-color,backdrop-filter;}',
      '.bb-wishlist-options-card .bb-product-card__options-modal.is-open .bb-product-card__options-backdrop{background-color:var(--bb-options-backdrop-bg);backdrop-filter:blur(var(--bb-options-backdrop-blur));-webkit-backdrop-filter:blur(var(--bb-options-backdrop-blur));}',
      '.bb-wishlist-options-card .bb-product-card__options-panel{position:relative;z-index:1;display:flex;flex-direction:column;width:min(100%,430px);max-height:min(78vh,620px);overflow:auto;margin:0;padding:16px;border:1px solid rgba(30,24,20,.1);border-radius:18px 18px 14px 14px;background:#fffaf4;color:#1e1c19;box-shadow:0 18px 46px rgba(0,0,0,.18);opacity:0;transform:translateY(42px) scale(.985);transform-origin:50% 100%;transition:opacity .36s ease,transform .52s cubic-bezier(.16,1,.3,1);}',
      '.bb-wishlist-options-card .bb-product-card__options-modal.is-open .bb-product-card__options-panel{opacity:1;transform:translateY(0) scale(1);}',
      '.bb-wishlist-options-card .bb-product-card__modal-media{display:flex;flex:0 0 auto;gap:8px;margin:-2px -2px 14px;padding:0 2px 4px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;}',
      '.bb-wishlist-options-card .bb-product-card__modal-media::-webkit-scrollbar{display:none;}',
      '.bb-wishlist-options-card .bb-product-card__modal-media-item{flex:0 0 min(74vw,292px);width:min(74vw,292px);height:min(74vw,292px);border-radius:13px;overflow:hidden;scroll-snap-align:start;background:#f3ece3;}',
      '.bb-wishlist-options-card .bb-product-card__modal-image{display:block;width:100%;height:100%;object-fit:cover;}',
      '.bb-wishlist-options-card .bb-product-card__options-head{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin-bottom:18px;}',
      '.bb-wishlist-options-card .bb-product-card__options-kicker{margin:0 0 5px;color:#6f6254;font-size:11px;font-weight:800;line-height:1;letter-spacing:.08em;text-transform:uppercase;}',
      '.bb-wishlist-options-card .bb-product-card__options-title{margin:0;color:#1e1c19;font-family:var(--font-accent--family,var(--font-heading--family,serif));font-size:18px;font-weight:800;line-height:1.08;}',
      '.bb-wishlist-options-card .bb-product-card__options-close{display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;flex:0 0 auto;padding:0;border:1px solid rgba(30,24,20,.12);border-radius:999px;background:#fff;color:#1e1c19;cursor:pointer;}',
      '.bb-wishlist-options-card .bb-product-card__options-close svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;}',
      '.bb-wishlist-options-card .bb-product-card__modal-form{display:grid;gap:14px;margin:0;}',
      '.bb-wishlist-options-card .bb-product-card__option-list{display:grid;gap:12px;}',
      '.bb-wishlist-options-card .bb-product-card__option-field{display:grid;gap:8px;min-width:0;margin:0;padding:0;border:0;}',
      '.bb-wishlist-options-card .bb-product-card__option-label,.bb-wishlist-options-card .bb-product-card__qty-label{color:#6f6254;font-size:12px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;}',
      '.bb-wishlist-options-card .bb-product-card__option-label{display:flex;align-items:baseline;justify-content:space-between;gap:10px;}',
      '.bb-wishlist-options-card .bb-product-card__selected-option{display:none;}',
      '.bb-wishlist-options-card .bb-product-card__option-select{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;}',
      '.bb-wishlist-options-card .bb-product-card__option-choices{display:flex;flex-wrap:wrap;gap:7px;min-width:0;}',
      '.bb-wishlist-options-card .bb-product-card__option-choice{display:inline-flex;align-items:center;justify-content:center;min-height:38px;padding:0 12px;border:1px solid rgba(30,24,20,.14);border-radius:999px;background:#fff;color:#1e1c19;cursor:pointer;font:inherit;font-size:13px;font-weight:700;line-height:1;transition:border-color .18s ease,background .18s ease,color .18s ease,opacity .18s ease,transform .18s ease;}',
      '.bb-wishlist-options-card .bb-product-card__option-choice.is-selected{border-color:#543334;background:#543334;color:#fff;}',
      '.bb-wishlist-options-card .bb-product-card__option-choice[hidden],.bb-wishlist-options-card .bb-product-card__option-choice.is-unavailable-hidden{display:none!important;}',
      '.bb-wishlist-options-card .bb-product-card__option-choice:disabled{opacity:.34;cursor:not-allowed;text-decoration:line-through;transform:none;}',
      '.bb-wishlist-options-card .bb-product-card__option-choice--color{justify-content:flex-start;min-height:40px;padding:0 12px 0 7px;gap:8px;max-width:100%;}',
      '.bb-wishlist-options-card .bb-product-card__option-swatch{display:block;width:25px;height:25px;flex:0 0 25px;border:1px solid rgba(30,24,20,.16);border-radius:999px;background:var(--bb-option-swatch,linear-gradient(135deg,#f9f5ec,#ddd2bf));box-shadow:inset 0 0 0 2px rgba(255,255,255,.65);}',
      '.bb-wishlist-options-card .bb-product-card__option-choice--color.is-selected .bb-product-card__option-swatch{border-color:rgba(255,255,255,.8);box-shadow:inset 0 0 0 2px rgba(255,255,255,.65),0 0 0 1px rgba(255,255,255,.5);}',
      '.bb-wishlist-options-card .bb-product-card__option-choice-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
      '.bb-wishlist-options-card .bb-product-card__qty-row{display:flex;align-items:center;justify-content:space-between;gap:14px;padding-top:2px;}',
      '.bb-wishlist-options-card .bb-product-card__qty-summary{min-height:20px;margin-top:-4px;color:#1e1c19;font-size:14px;font-weight:700;line-height:1.35;}',
      '.bb-wishlist-options-card .bb-product-card__qty-summary:empty{display:none;}',
      '.bb-wishlist-options-card .bb-product-card__qty-control{display:inline-flex;align-items:center;height:40px;border:1px solid rgba(30,24,20,.14);border-radius:999px;background:#fff;overflow:hidden;}',
      '.bb-wishlist-options-card .bb-product-card__qty-btn{display:inline-flex;align-items:center;justify-content:center;width:42px;height:40px;border:0;background:transparent;color:#1e1c19;cursor:pointer;font-size:18px;line-height:1;}',
      '.bb-wishlist-options-card .bb-product-card__qty-btn:disabled{color:rgba(30,28,25,.25);cursor:not-allowed;}',
      '.bb-wishlist-options-card .bb-product-card__qty-input{width:44px;height:40px;border:0;border-inline:1px solid rgba(30,24,20,.1);background:transparent;color:#1e1c19;font-size:15px;font-weight:800;text-align:center;appearance:textfield;}',
      '.bb-wishlist-options-card .bb-product-card__qty-input::-webkit-outer-spin-button,.bb-wishlist-options-card .bb-product-card__qty-input::-webkit-inner-spin-button{margin:0;appearance:none;}',
      '.bb-wishlist-options-card .bb-product-card__option-message{min-height:17px;margin:-3px 0 0;color:#7f3f2b;font-size:13px;line-height:1.3;}',
      '.bb-wishlist-options-card .bb-product-card__modal-submit{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:48px;padding:0 18px;border:0;border-radius:999px;background:#543334;color:#fff;cursor:pointer;font-family:\"Cormorant Garamond\",\"Cormorant\",Georgia,serif;font-size:19px;font-weight:600;line-height:1;}',
      '.bb-wishlist-options-card .bb-product-card__submit-total{display:inline-flex;align-items:center;font-size:.95em;opacity:.9;white-space:nowrap;}',
      '.bb-wishlist-options-card .bb-product-card__submit-total:empty{display:none;}',
      '.bb-wishlist-options-card .bb-product-card__modal-submit:disabled{background:#d7d0ca;color:rgba(17,17,17,.55);cursor:not-allowed;}',
      '.bb-wishlist-options-card--inline{grid-column:1/-1;position:static;inset:auto;z-index:auto;pointer-events:auto;}',
      '.bb-wishlist-options-card--inline .bb-product-card__options-modal{position:static;display:block;padding:0;opacity:1;pointer-events:auto;}',
      '.bb-wishlist-options-card--inline .bb-product-card__options-backdrop{display:none;}',
      '.bb-wishlist-options-card--inline .bb-product-card__options-panel{width:100%;max-height:none;overflow:visible;margin:8px 0 0;padding:14px;border-radius:12px;box-shadow:none;opacity:1;transform:none;transition:none;}',
      '@media (min-width:750px){.bb-wishlist-panel__add{width:auto;padding:0 13px;}.bb-wishlist-panel__add-label{display:inline;}}',
      '@media (max-width: 549px){.bb-wishlist-toast{bottom:14px;border-radius:8px;font-size:13px;}}',
      '@media (prefers-reduced-motion:reduce){.bb-wishlist-toast,.bb-wishlist-toast.is-visible,.bb-wishlist-toast.is-leaving{transition-duration:.01ms!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureHeaderPanel() {
    ensureToastStyles();

    var panel = document.querySelector('[data-bb-wishlist-panel]');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'bb-wishlist-panel';
    panel.dataset.bbWishlistPanel = '';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="bb-wishlist-panel__inner" role="dialog" aria-modal="true" aria-label="' + escapeHtml(t('favorites', 'Favoris')) + '">' +
        '<div class="bb-wishlist-panel__head">' +
          '<div><p class="bb-wishlist-panel__eyebrow">' + escapeHtml(t('account', 'Compte')) + '</p><h2 class="bb-wishlist-panel__title">' + escapeHtml(t('myFavorites', 'Mes favoris')) + '</h2></div>' +
          '<button class="bb-wishlist-panel__close" type="button" aria-label="' + escapeHtml(t('close', 'Fermer')) + '" data-bb-wishlist-panel-close>&times;</button>' +
        '</div>' +
        '<div data-bb-wishlist-panel-content></div>' +
      '</div>';

    document.body.appendChild(panel);
    panel.addEventListener('click', function (event) {
      if (event.target === panel || event.target.closest('[data-bb-wishlist-panel-close]')) {
        closeHeaderPanel();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeHeaderPanel();
    });

    return panel;
  }

  function openHeaderPanel(panel) {
    panel.hidden = false;
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
    });
  }

  function closeHeaderPanel() {
    var panel = document.querySelector('[data-bb-wishlist-panel]');
    if (!panel || panel.hidden) return;

    panel.classList.remove('is-open');
    window.setTimeout(function () {
      if (!panel.classList.contains('is-open')) {
        panel.hidden = true;
      }
    }, 360);
  }

  function productHandleFromItem(item) {
    if (item.handle) return item.handle;

    var itemUrl = String(item.url || '');
    var match = itemUrl.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i) ||
      itemUrl.match(/\/[a-z]{2}products\/([^/?#]+)/i);
    return match ? match[1] : '';
  }

  async function loadProductByHandle(handle) {
    handle = String(handle || '').trim();
    if (!handle) throw new Error('missing_handle');
    if (productCache[handle]) return productCache[handle];

    var rootUrl = String(config.rootUrl || '').replace(/\/+$/, '');
    var productJsonUrl = (rootUrl && rootUrl !== '/' ? rootUrl : '') + '/products/' + encodeURIComponent(handle) + '.js';
    var response = await fetch(productJsonUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('product_load_failed');
    var product = await response.json();
    productCache[handle] = product;
    return product;
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; });
  }

  function productOptionNames(product) {
    return (product.options || []).map(function (option, index) {
      if (typeof option === 'string') return option;
      return option.name || ('Option ' + (index + 1));
    });
  }

  function addUniqueOptionValue(values, value) {
    if (value == null || value === '') return;
    if (values.indexOf(value) === -1) values.push(value);
  }

  function productOptionValues(product, optionNames) {
    var valuesByOption = optionNames.map(function () { return []; });

    (product.options || []).forEach(function (option, index) {
      if (!valuesByOption[index] || typeof option !== 'object' || !Array.isArray(option.values)) return;

      option.values.forEach(function (value) {
        addUniqueOptionValue(valuesByOption[index], value);
      });
    });

    (product.variants || []).forEach(function (variant) {
      variantOptions(variant).forEach(function (value, index) {
        if (!valuesByOption[index]) valuesByOption[index] = [];
        addUniqueOptionValue(valuesByOption[index], value);
      });
    });

    return valuesByOption;
  }

  function sellableVariants(product) {
    return (product.variants || []).filter(function (variant) {
      return variant && variant.available !== false;
    });
  }

  function formatCents(cents) {
    var value = Number(cents || 0) / 100;
    var locale = String(config.locale || document.documentElement.lang || navigator.language || 'fr-FR');
    var currency = String(
      config.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'EUR'
    );
    try {
      return value.toLocaleString(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: currency === 'CHF' ? 'code' : 'symbol'
      });
    } catch (_error) {
      return value.toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }

  async function loadMeterPriceCentsByHandle(handle) {
    handle = String(handle || '').trim();
    if (!handle) throw new Error('missing_handle');
    if (Object.prototype.hasOwnProperty.call(meterPriceCache, handle)) return meterPriceCache[handle];

    var rootUrl = String(config.rootUrl || '').replace(/\/+$/, '');
    var productUrl = (rootUrl && rootUrl !== '/' ? rootUrl : '') + '/products/' + encodeURIComponent(handle);
    var response = await fetch(
      productUrl + '?section_id=blankabric-product-meter-price-data',
      {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      }
    );
    if (!response.ok) throw new Error('meter_price_load_failed');

    var html = await response.text();
    var sectionDocument = new DOMParser().parseFromString(html, 'text/html');
    var priceNode = sectionDocument.querySelector('[data-bb-product-meter-price][data-meter-price-cents]');
    var meterPriceCents = Number(priceNode && priceNode.dataset.meterPriceCents);
    if (!Number.isFinite(meterPriceCents)) throw new Error('meter_price_missing');

    var priceData = {
      cents: meterPriceCents,
      display: String((priceNode && priceNode.dataset.priceDisplay) || '').trim()
    };
    meterPriceCache[handle] = priceData;
    return priceData;
  }

  async function localizeWishlistItem(item) {
    var handle = productHandleFromItem(item);
    if (!handle) return item;

    try {
      var localizedData = await Promise.all([
        loadProductByHandle(handle),
        loadMeterPriceCentsByHandle(handle)
      ]);
      var product = localizedData[0];
      var meterPriceData = localizedData[1];
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '') || item.image || '';
      var localizedPrice = meterPriceData.display || formatCents(meterPriceData.cents);
      var rootUrl = String(config.rootUrl || '').replace(/\/+$/, '');
      var productUrl = (rootUrl && rootUrl !== '/' ? rootUrl : '') + '/products/' + encodeURIComponent(handle);

      return Object.assign({}, item, {
        available: product.available !== false && variants.some(function (variant) { return variant.available !== false; }),
        handle: handle,
        image: image,
        meterPrice: localizedPrice,
        price: localizedPrice,
        productGid: product.id ? 'gid://shopify/Product/' + product.id : item.productGid,
        productId: product.id ? String(product.id) : item.productId,
        title: product.title || item.title,
        url: productUrl
      });
    } catch (_error) {
      return item;
    }
  }

  async function localizeWishlistItems(items) {
    items = Array.isArray(items) ? items : [];
    var localized = [];

    for (var index = 0; index < items.length; index += 6) {
      var batch = await Promise.all(items.slice(index, index + 6).map(localizeWishlistItem));
      localized = localized.concat(batch);
    }

    return localized;
  }

  function findVariantFromSelection(product, selected) {
    if (!selected.length) return sellableVariants(product)[0] || null;

    return sellableVariants(product).find(function (variant) {
      var options = variantOptions(variant);
      return options.every(function (value, index) {
        return String(value) === String(selected[index]);
      });
    }) || null;
  }

  function hasSellableMatch(product, selected, optionIndex, value) {
    return sellableVariants(product).some(function (variant) {
      var options = variantOptions(variant);
      if (String(options[optionIndex]) !== String(value)) return false;

      return options.every(function (optionValue, index) {
        return index === optionIndex || !selected[index] || String(selected[index]) === String(optionValue);
      });
    });
  }

  function optionValuesFor(product, selected, optionIndex, stableOptionValues) {
    var values = stableOptionValues && stableOptionValues[optionIndex] ? stableOptionValues[optionIndex] : [];

    return values.filter(function (value) {
      return hasSellableMatch(product, selected, optionIndex, value);
    });
  }

  function normalizeSelection(product, selected, optionNames, stableOptionValues) {
    var normalized = selected.slice(0, optionNames.length);

    for (var pass = 0; pass < Math.max(optionNames.length, 1); pass += 1) {
      var changed = false;

      optionNames.forEach(function (_name, index) {
        var values = optionValuesFor(product, normalized, index, stableOptionValues);
        var current = normalized[index];
        var next = values.indexOf(current) > -1 ? current : values[0];

        if (next !== current) {
          normalized[index] = next || '';
          changed = true;
        }
      });

      if (!changed) break;
    }

    return normalized;
  }

  function initialSelection(product) {
    var first = sellableVariants(product)[0] || (product.variants || [])[0] || {};
    return variantOptions(first);
  }

  function getSwatchColor(value) {
    switch (String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-')) {
      case 'blanc':
      case 'blanc-optique':
      case 'white':
      case 'optical-white':
      case 'weiss':
      case 'optisches-weiss':
        return '#f8f7f2';
      case 'blanc-naturel':
      case 'naturel':
      case 'natural-white':
      case 'naturweiss':
        return '#ede7dc';
      case 'ivoire':
      case 'ivoire-clair':
      case 'ivory':
      case 'light-ivory':
      case 'elfenbein':
      case 'helles-elfenbein':
        return '#f3ead8';
      case 'ecru':
      case 'ecru-clair':
        return '#e8ddc8';
      case 'creme':
      case 'cream':
        return '#e4d4bd';
      case 'beige':
        return '#d8c7aa';
      case 'porcelaine':
      case 'porcelain':
      case 'porzellan':
        return '#f1eee8';
      case 'bleu-ciel':
      case 'light-blue':
      case 'hellblau':
        return '#dceaf2';
      case 'bleu-glacier':
      case 'glacier-blue':
      case 'gletscherblau':
        return '#d7e0e2';
      case 'blanc-glacier':
      case 'glacier-white':
      case 'gletscherweiss':
        return '#eef0ed';
      default:
        return '';
    }
  }

  function isColorOptionName(name) {
    var normalised = String(name || '').toLowerCase();
    return normalised.indexOf('couleur') > -1 || normalised.indexOf('color') > -1 || normalised.indexOf('farbe') > -1;
  }

  function productModalMedia(product) {
    var images = Array.isArray(product && product.images) ? product.images.slice(0, 6) : [];

    if (!images.length && product && product.featured_image) {
      images = [product.featured_image];
    }

    var media = images.map(function (image) {
      var url = typeof image === 'string' ? image : (image && (image.src || image.url)) || '';
      if (!url) return '';

      var sizedUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=720';
      return '<div class="bb-product-card__modal-media-item">' +
        '<img class="bb-product-card__modal-image" src="' + escapeHtml(sizedUrl) + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy">' +
      '</div>';
    }).join('');

    return media
      ? '<div class="bb-product-card__modal-media" aria-label="' + escapeHtml(product.title || '') + '">' + media + '</div>'
      : '';
  }

  function getMaxQuantity(variant) {
    if (!variant) return null;
    if (variant.inventory_policy === 'continue') return null;
    if (!variant.inventory_management) return null;

    var quantity = Number(variant.inventory_quantity);
    if (Number.isFinite(quantity) && quantity > 0) return quantity;
    return null;
  }

  function closeWishlistOptionsModal(targetWrapper) {
    var wrappers = targetWrapper
      ? [targetWrapper]
      : Array.from(document.querySelectorAll('[data-bb-wishlist-product-options]'));

    wrappers.forEach(function (wrapper) {
      var modal = wrapper.querySelector('[data-bb-options-modal]');
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }

      wrapper.classList.remove('bb-options-active');
      window.setTimeout(function () {
        if (wrapper.parentNode) wrapper.remove();
      }, 780);
    });
  }

  function openWishlistProductOptions(product, targetItem) {
    var variants = sellableVariants(product);
    if (!variants.length) {
      showAccountToast();
      return;
    }

    closeWishlistOptionsModal();
    var inline = Boolean(targetItem && window.matchMedia('(min-width: 750px)').matches);

    var optionNames = productOptionNames(product);
    var selected = initialSelection(product);
    var stableOptionValues = productOptionValues(product, optionNames);
    var qty = 1;

    if (optionNames.length === 1 && String(selected[0] || '').toLowerCase() === 'default title') {
      optionNames = [];
      selected = [];
      stableOptionValues = [];
    }

    selected = normalizeSelection(product, selected, optionNames, stableOptionValues);

    var wrapper = document.createElement('div');
    wrapper.className = 'bb-product-card bb-wishlist-options-card bb-options-active' + (inline ? ' bb-wishlist-options-card--inline' : '');
    wrapper.dataset.bbWishlistProductOptions = '';
    if (inline) {
      targetItem.appendChild(wrapper);
    } else {
      document.body.appendChild(wrapper);
    }

    var optionsModalOpen = false;
    var optionsOpenFrame = 0;

    function revealOptionsModal() {
      var modal = wrapper.querySelector('[data-bb-options-modal]');
      if (!modal) return;

      if (optionsModalOpen || inline) {
        modal.classList.add('is-open');
        optionsModalOpen = true;
        return;
      }

      if (optionsOpenFrame) {
        window.cancelAnimationFrame(optionsOpenFrame);
      }

      optionsOpenFrame = window.requestAnimationFrame(function () {
        optionsOpenFrame = window.requestAnimationFrame(function () {
          optionsOpenFrame = 0;
          optionsModalOpen = true;
          modal.classList.add('is-open');
        });
      });
    }

    function render() {
      selected = normalizeSelection(product, selected, optionNames, stableOptionValues);

      var variant = findVariantFromSelection(product, selected);
      var maxQty = getMaxQuantity(variant);
      var available = Boolean(variant);

      if (maxQty !== null && qty > maxQty) qty = Math.max(1, maxQty);

      var total = variant ? formatCents(Number(variant.price || 0) * qty) : '';
      var optionsHtml = optionNames.map(function (name, index) {
        var values = optionValuesFor(product, selected, index, stableOptionValues);
        if (!values.length) return '';
        var isColor = isColorOptionName(name);

        return '<fieldset class="bb-product-card__option-field' + (isColor ? ' bb-product-card__option-field--color' : '') + '" data-bb-option-field data-option-position="' + (index + 1) + '">' +
          '<legend class="bb-product-card__option-label"><span>' + escapeHtml(name) + '</span>' +
            (isColor ? '<span class="bb-product-card__selected-option" data-bb-selected-option-value>' + escapeHtml(selected[index] || '') + '</span>' : '') +
          '</legend>' +
          '<select class="bb-product-card__option-select" data-bb-option-select data-option-position="' + (index + 1) + '" aria-hidden="true" tabindex="-1">' +
            values.map(function (value) {
              return '<option value="' + escapeHtml(value) + '"' + (String(selected[index]) === String(value) ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
            }).join('') +
          '</select>' +
          '<div class="bb-product-card__option-choices' + (isColor ? ' bb-product-card__option-choices--color' : ' bb-product-card__option-choices--pills') + '" role="group" aria-label="' + escapeHtml(name) + '">' +
            values.map(function (value) {
              var swatch = isColor ? '<span class="bb-product-card__option-swatch" ' + (getSwatchColor(value) ? 'style="--bb-option-swatch: ' + getSwatchColor(value) + ';"' : '') + ' aria-hidden="true"></span>' : '';

              return '<button type="button" class="bb-product-card__option-choice' + (isColor ? ' bb-product-card__option-choice--color' : '') + (String(selected[index]) === String(value) ? ' is-selected' : '') + '" data-bb-option-choice data-option-position="' + (index + 1) + '" data-option-value="' + escapeHtml(value) + '" aria-pressed="' + (String(selected[index]) === String(value) ? 'true' : 'false') + '">' +
                swatch +
                '<span class="bb-product-card__option-choice-text">' + escapeHtml(value) + '</span>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</fieldset>';
      }).join('');

      wrapper.innerHTML =
        '<div class="bb-product-card__options-modal' + (optionsModalOpen ? ' is-open' : '') + '" data-bb-options-modal aria-hidden="false">' +
          '<button class="bb-product-card__options-backdrop" type="button" aria-label="' + escapeHtml(t('close', 'Fermer')) + '" data-bb-options-close></button>' +
          '<div class="bb-product-card__options-panel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(t('chooseOptions', 'Choisir les options')) + '">' +
            productModalMedia(product) +
            '<div class="bb-product-card__options-head">' +
              '<div>' +
                '<p class="bb-product-card__options-kicker">' + escapeHtml(t('addToCart', 'Ajouter au panier')) + '</p>' +
                '<h3 class="bb-product-card__options-title">' + escapeHtml(product.title || t('productFallback', 'Produit')) + '</h3>' +
              '</div>' +
              '<button class="bb-product-card__options-close" type="button" aria-label="' + escapeHtml(t('close', 'Fermer')) + '" data-bb-options-close>' +
                '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
              '</button>' +
            '</div>' +
            '<form class="bb-product-card__modal-form" action="' + escapeHtml(localizeStorefrontUrl('/cart/add')) + '" method="post" data-bb-options-form data-bb-wishlist-cart-form>' +
              '<input type="hidden" name="id" value="' + escapeHtml(variant ? variant.id : '') + '" data-bb-variant-id>' +
              (optionsHtml ? '<div class="bb-product-card__option-list">' + optionsHtml + '</div>' : '') +
              '<div class="bb-product-card__qty-row">' +
                '<span class="bb-product-card__qty-label">' + escapeHtml(t('quantity', 'Quantite')) + '</span>' +
                '<div class="bb-product-card__qty-control">' +
                  '<button type="button" class="bb-product-card__qty-btn" data-bb-qty-minus ' + (!available || qty <= 1 ? 'disabled' : '') + ' aria-label="' + escapeHtml(t('decreaseQuantity', 'Diminuer')) + '">-</button>' +
                  '<input class="bb-product-card__qty-input" type="number" name="quantity" min="1" ' + (maxQty !== null ? 'max="' + maxQty + '"' : '') + ' value="' + qty + '" inputmode="numeric" data-bb-qty-input ' + (!available ? 'disabled' : '') + '>' +
                  '<button type="button" class="bb-product-card__qty-btn" data-bb-qty-plus ' + (!available || (maxQty !== null && qty >= maxQty) ? 'disabled' : '') + ' aria-label="' + escapeHtml(t('increaseQuantity', 'Augmenter')) + '">+</button>' +
                '</div>' +
              '</div>' +
              '<div class="bb-product-card__qty-summary" data-bb-qty-summary aria-live="polite">' + (maxQty !== null && qty >= maxQty ? escapeHtml(t('maxQuantity', 'Quantite maximale atteinte pour cette option.')) : '') + '</div>' +
              '<p class="bb-product-card__option-message" data-bb-option-message>' + (!variant ? escapeHtml(t('combinationUnavailable', 'Cette combinaison est indisponible.')) : '') + '</p>' +
              '<button class="bb-product-card__modal-submit" type="submit" data-bb-submit ' + (!available ? 'disabled' : '') + '>' +
                '<span data-bb-submit-text>' + escapeHtml(available ? t('addToCart', 'Ajouter au panier') : t('unavailable', 'Indisponible')) + '</span>' +
                '<span class="bb-product-card__submit-total" data-bb-submit-total>' + (total ? '- ' + escapeHtml(total) : '') + '</span>' +
              '</button>' +
            '</form>' +
          '</div>' +
        '</div>';

      revealOptionsModal();
    }

    wrapper.addEventListener('click', function (event) {
      if (event.target.closest('[data-bb-options-close]')) {
        event.preventDefault();
        closeWishlistOptionsModal();
        return;
      }

      var optionButton = event.target.closest('[data-bb-option-choice]');
      if (optionButton) {
        var index = Math.max(0, Number(optionButton.dataset.optionPosition || 1) - 1);
        selected[index] = optionButton.dataset.optionValue || '';
        selected = normalizeSelection(product, selected, optionNames, stableOptionValues);

        render();
        return;
      }

      if (event.target.closest('[data-bb-qty-minus]')) {
        qty = Math.max(1, qty - 1);
        render();
        return;
      }

      if (event.target.closest('[data-bb-qty-plus]')) {
        var variant = findVariantFromSelection(product, selected);
        var maxQty = getMaxQuantity(variant);
        qty += 1;
        if (maxQty !== null && qty > maxQty) qty = maxQty;
        render();
      }
    });

    wrapper.addEventListener('input', function (event) {
      if (!event.target.matches('[data-bb-qty-input]')) return;
      qty = Math.max(1, parseInt(event.target.value || '1', 10) || 1);
      render();
    });

    wrapper.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-bb-wishlist-cart-form]');
      if (!form) return;

      event.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      var error = form.querySelector('[data-bb-option-message]');
      if (submit) submit.disabled = true;
      if (error) error.textContent = '';

      try {
        var response = await fetch(localizeStorefrontUrl('/cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        var data = await response.json().catch(function () { return null; });
        if (!response.ok) {
          throw new Error((data && (data.description || data.message)) || t('addQuantityError', 'Impossible d ajouter cette quantite.'));
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item: data } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item: data } }));
        trackPricingCartAdd(product.id, data && data.variant_id, qty, 'wishlist');

        if (window.BlankabricCartDrawer && typeof window.BlankabricCartDrawer.open === 'function') {
          window.BlankabricCartDrawer.open();
        }

        closeWishlistOptionsModal();
        if (!inline) closeHeaderPanel();
      } catch (errorMessage) {
        if (error) error.textContent = errorMessage.message || t('addProductError', 'Impossible d ajouter ce produit.');
      } finally {
        if (submit) submit.disabled = false;
      }
    });

    render();
  }

  function wishlistMeterPrice(item) {
    var value = String((item && (item.meterPrice || item.price)) || '').trim();
    return value;
  }

  function renderHeaderPanelItems(panel, items) {
    var content = panel.querySelector('[data-bb-wishlist-panel-content]');
    if (!content) return;

    if (!items || !items.length) {
      content.innerHTML = '<p class="bb-wishlist-panel__message">' + escapeHtml(t('empty', 'Vous n\'avez pas encore ajoute d\'article en favori.')) + '</p>';
      return;
    }

    content.innerHTML = '<div class="bb-wishlist-panel__grid">' + items.map(function (item) {
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '';

      return '<article class="bb-wishlist-panel__item" data-bb-wishlist-sidebar-item data-bb-wishlist-product data-product-id="' + escapeHtml(item.productId) + '" data-handle="' + escapeHtml(productHandleFromItem(item)) + '">' +
        '<a class="bb-wishlist-panel__media" href="' + escapeHtml(localizeStorefrontUrl(item.url)) + '">' + image + '</a>' +
        '<div>' +
          '<h3 class="bb-wishlist-panel__item-title"><a href="' + escapeHtml(localizeStorefrontUrl(item.url)) + '">' + escapeHtml(item.title || t('productFallback', 'Produit')) + '</a></h3>' +
          '<p class="bb-wishlist-panel__price">' + escapeHtml(wishlistMeterPrice(item)) + '</p>' +
          '<p class="bb-wishlist-panel__status">' + escapeHtml(item.available ? t('available', 'Disponible') : t('possiblySold', 'En attente de réapprovisionnement')) + '</p>' +
          '<div class="bb-wishlist-panel__actions">' +
            '<button class="bb-wishlist-panel__add" type="button" data-bb-wishlist-open-cart-options aria-label="' + escapeHtml(t('addToCart', 'Ajouter au panier')) + '" ' + (!item.available ? 'disabled' : '') + '><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 8.5h11l-.75 11h-9.5l-.75-11Z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/></svg><span class="bb-wishlist-panel__add-label">' + escapeHtml(t('add', 'Ajouter')) + '</span></button>' +
            '<button class="bb-wishlist-panel__favorite is-liked" type="button" aria-label="' + escapeHtml(t('removeFromFavorites', 'Retirer des favoris')) + '" aria-pressed="true" data-bb-wishlist-toggle data-wishlist-liked="true" data-product-id="' + escapeHtml(item.productId) + '" data-product-gid="' + escapeHtml(item.productGid || '') + '" data-product-handle="' + escapeHtml(productHandleFromItem(item)) + '" data-product-title="' + escapeHtml(item.title || '') + '" data-product-url="' + escapeHtml(localizeStorefrontUrl(item.url)) + '" data-product-image="' + escapeHtml(item.image || '') + '" data-product-price="' + escapeHtml(wishlistMeterPrice(item)) + '" data-product-available="' + (item.available ? 'true' : 'false') + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('') + '</div>';
  }

  async function showHeaderWishlistPanel() {
    var panel = ensureHeaderPanel();
    var content = panel.querySelector('[data-bb-wishlist-panel-content]');
    openHeaderPanel(panel);

    if (content) {
      content.innerHTML = '<p class="bb-wishlist-panel__message">' + escapeHtml(t('loading', 'Chargement des favoris...')) + '</p>';
    }

    var remote = await loadRemoteList();
    if (remote && Array.isArray(remote.items)) {
      renderHeaderPanelItems(panel, await localizeWishlistItems(remote.items));
      return;
    }

    renderHeaderPanelItems(panel, await localizeWishlistItems(localItems));
  }

  async function refreshOpenHeaderPanel() {
    var panel = document.querySelector('[data-bb-wishlist-panel]');
    if (!panel || panel.hidden) return;

    var content = panel.querySelector('[data-bb-wishlist-panel-content]');
    if (content) {
      content.innerHTML = '<p class="bb-wishlist-panel__message">' + escapeHtml(t('updating', 'Mise a jour des favoris...')) + '</p>';
    }

    var remote = await loadRemoteList();
    if (remote && Array.isArray(remote.items)) {
      renderHeaderPanelItems(panel, await localizeWishlistItems(remote.items));
      return;
    }

    renderHeaderPanelItems(panel, await localizeWishlistItems(localItems));
  }

  function onHeaderWishlistClick(event) {
    var link = event.target.closest('[data-bb-wishlist-header-link]');
    if (!link) return;

    event.preventDefault();

    var accountMenu = link.closest('details');
    if (accountMenu) accountMenu.open = false;

    showHeaderWishlistPanel();
  }

  async function onWishlistOptionsClick(event) {
    var button = event.target.closest('[data-bb-wishlist-open-cart-options]');
    if (!button) return;

    event.preventDefault();
    var item = button.closest('[data-bb-wishlist-sidebar-item]');
    if (!item) return;

    var existingInline = item.querySelector('[data-bb-wishlist-product-options]');
    if (existingInline && window.matchMedia('(min-width: 750px)').matches) {
      closeWishlistOptionsModal(existingInline);
      return;
    }

    button.disabled = true;

    try {
      var product = await loadProductByHandle(item.dataset.handle || '');
      openWishlistProductOptions(product, item.matches('[data-bb-wishlist-page-card]') ? null : item);
    } catch (_error) {
      showAccountToast();
    } finally {
      button.disabled = false;
    }
  }

  function animateWishlistRemoval(productId) {
    productId = normaliseId(productId);
    var page = document.querySelector('[data-bb-wishlist-page]');
    var grid = page && page.querySelector('[data-bb-wishlist-grid]');
    var empty = page && page.querySelector('[data-bb-wishlist-empty]');
    var pageCards = grid ? Array.from(grid.querySelectorAll('[data-bb-wishlist-page-card]')) : [];
    var card = pageCards.find(function (item) {
      return normaliseId(item.dataset.productId) === productId;
    });
    var remainingCards = pageCards.filter(function (item) { return item !== card; });
    var previousPositions = new Map();

    remainingCards.forEach(function (item) {
      previousPositions.set(item, item.getBoundingClientRect());
    });

    var panelItems = Array.from(document.querySelectorAll('[data-bb-wishlist-sidebar-item]')).filter(function (item) {
      return !item.matches('[data-bb-wishlist-page-card]') && normaliseId(item.dataset.productId) === productId;
    });
    var panelContents = Array.from(new Set(panelItems.map(function (item) {
      return item.closest('[data-bb-wishlist-panel-content]');
    }).filter(Boolean)));
    var targets = (card ? [card] : []).concat(panelItems);

    targets.forEach(function (item) {
      item.classList.add('is-removing');
      item.setAttribute('aria-hidden', 'true');
    });

    window.setTimeout(function () {
      targets.forEach(function (item) {
        if (item.parentNode) item.remove();
      });

      if (grid && card) {
        var visibleCards = grid.querySelectorAll('[data-bb-wishlist-page-card]');
        grid.hidden = visibleCards.length === 0;
        if (empty) empty.hidden = visibleCards.length > 0;

        remainingCards.forEach(function (item) {
          if (!item.parentNode) return;
          var previous = previousPositions.get(item);
          var current = item.getBoundingClientRect();
          var offsetX = previous.left - current.left;
          var offsetY = previous.top - current.top;
          if (!offsetX && !offsetY) return;

          item.style.transition = 'none';
          item.style.transform = 'translate(' + offsetX + 'px,' + offsetY + 'px)';
          window.requestAnimationFrame(function () {
            item.style.transition = 'transform .46s cubic-bezier(.16,1,.3,1)';
            item.style.transform = '';
            window.setTimeout(function () {
              item.style.transition = '';
            }, 480);
          });
        });
      }

      panelContents.forEach(function (panelContent) {
        if (panelContent && !panelContent.querySelector('[data-bb-wishlist-sidebar-item]')) {
          panelContent.innerHTML = '<p class="bb-wishlist-panel__message">' + escapeHtml(t('empty', 'Vous n\'avez pas encore ajouté d\'article en favori.')) + '</p>';
        }
      });
    }, 320);
  }

  async function onToggle(event) {
    var button = event.target.closest('[data-bb-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    var product = collectProductData(button);
    if (!product.productId) return;

    var nextLiked = button.dataset.wishlistLiked !== 'true';
    if (!isCustomerLoggedIn()) {
      beginCustomerAuthentication({ type: 'toggle', product: product, liked: nextLiked });
      return;
    }

    button.disabled = true;

    var remote = await toggleRemote(product, nextLiked);
    button.disabled = false;

    if (!remote) {
      if (customerStorageId()) {
        applyLocalWishlistState(product, nextLiked);
        if (nextLiked) {
          animateProductCardHeart(product.productId);
          showWishlistAddedToast(favoriteAddedMessage(product));
        } else {
          animateWishlistRemoval(product.productId);
        }
        return;
      }

      if (lastRemoteError && lastRemoteError.status === 401) {
        beginCustomerAuthentication({ type: 'toggle', product: product, liked: nextLiked });
      } else {
        showAccountToast(t('addProductError', 'Impossible d ajouter ce produit.'));
      }
      return;
    }

    setProductState(product.productId, remote.liked, remote.count);

    if (nextLiked && remote.liked) {
      animateProductCardHeart(product.productId);
      showWishlistAddedToast(favoriteAddedMessage(product));
    }
    if (!nextLiked && !remote.liked) animateWishlistRemoval(product.productId);

    hydrateSummary();

    document.dispatchEvent(new CustomEvent('blankabric:wishlist:change', {
      detail: { productId: product.productId, liked: remote.liked, count: remote.count }
    }));
  }

  function renderWishlistPage(items) {
    var page = document.querySelector('[data-bb-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-bb-wishlist-grid]');
    var empty = page.querySelector('[data-bb-wishlist-empty]');
    var accountNote = page.querySelector('[data-bb-wishlist-account-note]');
    if (!grid || !empty) return;

    var guestPreview = !isCustomerLoggedIn();
    items = guestPreview ? [] : (Array.isArray(items) ? items : []);
    page.classList.toggle('is-guest-preview', guestPreview);
    empty.hidden = guestPreview || items.length > 0;
    grid.hidden = guestPreview || items.length === 0;

    if (accountNote) {
      var authUrl = customerAuthenticationUrl(true) || config.loginUrl || '/account/login';
      accountNote.hidden = !guestPreview;
      accountNote.innerHTML = guestPreview
        ? '<p class="bb-wishlist-page__gate-eyebrow">' + escapeHtml(t('accountRequired', 'Compte requis')) + '</p>' +
          '<h2>' + escapeHtml(guestOfferTitle()) + '</h2>' +
          '<p>' + escapeHtml(guestOfferText()) + '</p>' +
          guestOfferHtml() +
          '<div class="bb-wishlist-page__gate-actions">' +
            '<a class="bb-wishlist-page__gate-primary" href="' + escapeHtml(authUrl) + '">' + escapeHtml(t('createMyAccount', 'Créer mon compte')) + '</a>' +
            '<a class="bb-wishlist-page__gate-secondary" href="' + escapeHtml(authUrl) + '">' + escapeHtml(t('alreadyHaveAccount', 'J’ai déjà un compte')) + '</a>' +
          '</div>'
        : '';
    }

    grid.innerHTML = items.map(function (item) {
      var availableText = item.available ? t('available', 'Disponible') : t('possiblySold', 'En attente de réapprovisionnement');
      var productUrl = localizeStorefrontUrl(item.url);
      var handle = productHandleFromItem(item);
      var price = wishlistMeterPrice(item);
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '<span class="bb-wishlist-page__placeholder"></span>';

      return '<article class="bb-wishlist-page__card bb-product-card" data-bb-wishlist-page-card data-bb-wishlist-sidebar-item data-bb-wishlist-product data-product-id="' + escapeHtml(item.productId) + '" data-handle="' + escapeHtml(handle) + '">' +
        '<div class="bb-wishlist-page__media-wrap">' +
          '<a class="bb-wishlist-page__media" href="' + escapeHtml(productUrl) + '">' + image + '</a>' +
          '<button class="bb-wishlist-page__heart is-liked" type="button" aria-label="' + escapeHtml(t('removeFromFavorites', 'Retirer des favoris')) + '" aria-pressed="true" data-bb-wishlist-toggle data-wishlist-liked="true" data-product-id="' + escapeHtml(item.productId) + '" data-product-gid="' + escapeHtml(item.productGid || '') + '" data-product-handle="' + escapeHtml(handle) + '" data-product-title="' + escapeHtml(item.title || '') + '" data-product-url="' + escapeHtml(productUrl) + '" data-product-image="' + escapeHtml(item.image || '') + '" data-product-price="' + escapeHtml(price) + '" data-product-available="' + (item.available ? 'true' : 'false') + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bb-wishlist-page__card-body">' +
          '<a class="bb-wishlist-page__title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(item.title || t('productFallback', 'Produit')) + '</a>' +
          '<p class="bb-wishlist-page__status">' + escapeHtml(availableText) + '</p>' +
          '<div class="bb-wishlist-page__bottom">' +
            '<a class="bb-wishlist-page__price" href="' + escapeHtml(productUrl) + '">' + escapeHtml(price) + '</a>' +
            '<button class="bb-wishlist-page__cart" type="button" data-bb-wishlist-open-cart-options aria-label="' + escapeHtml(t('addToCart', 'Ajouter au panier')) + '" ' + (!item.available ? 'disabled' : '') + '><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 8.5h11l-.75 11h-9.5l-.75-11Z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/></svg><span>' + escapeHtml(t('add', 'Ajouter')) + '</span></button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  async function hydrateWishlistPage() {
    var page = document.querySelector('[data-bb-wishlist-page]');
    if (!page) return;

    var remote = await loadRemoteList();
    if (remote && Array.isArray(remote.items)) {
      renderWishlistPage(await localizeWishlistItems(remote.items));
      return;
    }

    renderWishlistPage(isCustomerLoggedIn() ? await localizeWishlistItems(localItems) : null);
  }

  async function onRemove(event) {
    var button = event.target.closest('[data-bb-wishlist-remove]');
    if (!button) return;

    event.preventDefault();
    var productId = normaliseId(button.dataset.productId);
    button.disabled = true;
    var remote = await removeRemote(productId, button.dataset.productGid || '');

    if (!remote) {
      button.disabled = false;
      if (customerStorageId()) {
        var localProduct = getLocalItem(productId) || {
          productId: productId,
          productGid: button.dataset.productGid || ''
        };
        applyLocalWishlistState(localProduct, false);
        animateWishlistRemoval(productId);
        return;
      }

      if (lastRemoteError && lastRemoteError.status === 401) {
        beginCustomerAuthentication({
          type: 'remove',
          productId: productId,
          productGid: button.dataset.productGid || ''
        });
      } else {
        showAccountToast(t('addProductError', 'Impossible de mettre a jour ce favori.'));
      }
      return;
    }

    setProductState(productId, false, remote.count || 0);

    animateWishlistRemoval(productId);
    hydrateSummary();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  async function init(scope) {
    scope = scope || document;
    ensureToastStyles();

    var wishlistPage = document.querySelector('[data-bb-wishlist-page]');
    if (wishlistPage && !customerStorageId() && !window.BlankabricWishlistAuthResult) {
      beginCustomerAuthentication(null);
      return;
    }

    hydrateLocalButtons();
    await replayAuthPendingAction();
    await flushPendingOperations();

    await Promise.all([
      trackCurrentProductView(),
      hydrateSummary(),
      hydrateRemoteButtons(),
      hydrateWishlistPage()
    ]);

    if (window.BlankabricWishlistAuthResult === 'required' && !wishlistPage) {
      showHeaderLoginMessage();
    } else if (window.BlankabricWishlistAuthResult === 'error') {
      showHeaderLoginMessage();
    }
  }

  document.addEventListener('click', onToggle);
  document.addEventListener('click', onRemove);
  document.addEventListener('click', onHeaderWishlistClick);
  document.addEventListener('click', onWishlistOptionsClick);
  function onCartUpdate(event) {
    var detail = event && event.detail && event.detail.data;
    if (!detail || detail.didError || detail.source !== 'product-form-component') return;
    trackPricingCartAdd(detail.productId, detail.variantId || (event.detail && event.detail.sourceId), detail.itemCount, 'product-form');
  }

  document.addEventListener('cart:update', onCartUpdate);
  var pendingCartUpdates = window.BlankabricPendingWishlistCartUpdates;
  window.BlankabricPendingWishlistCartUpdates = [];
  if (Array.isArray(pendingCartUpdates)) {
    pendingCartUpdates.forEach(function (detail) { onCartUpdate({ detail: detail }); });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeWishlistOptionsModal();
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && !customerStorageId()) window.location.reload();
  });
  window.addEventListener('online', function () {
    flushPendingOperations().then(function (changed) {
      if (!changed) return;
      hydrateSummary();
      hydrateRemoteButtons();
      hydrateWishlistPage();
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.BlankabricWishlist = {
    init: init,
    renderPage: hydrateWishlistPage,
    getItems: function () { return localItems.slice(); },
    refreshSummary: hydrateSummary,
    openProductOptions: function (product) {
      ensureToastStyles();
      openWishlistProductOptions(product, null);
    }
  };
})();
